import { render, staticRenderFns } from "./StandingTable.vue?vue&type=template&id=04ec666a&scoped=true&"
import script from "./StandingTable.vue?vue&type=script&lang=js&"
export * from "./StandingTable.vue?vue&type=script&lang=js&"
import style0 from "./StandingTable.vue?vue&type=style&index=0&id=04ec666a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec666a",
  null
  
)

export default component.exports